import React from "react";
import Jumbotron from "../components/Jumbotron";
import SubNav from "../components/sub-nav";
import SectionTitle from "../components/SectionTitle";
import NewsItem from "../components/news-item";
import PageWrapper from "../components/PageWrapper";
import styles from "../styles/news.module.scss";

function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

const renderItems = (array = []) => {
	return array.map((item, i) => {
		if (item.cat !== null) {
			return (
				<div key={"news-" + (i + 1)} className="col-12 card mb-3">
					<NewsItem
						className={"row"}
						category={item.cat || "Undefined"}
						category_url={"/" + item.node_locale +"/news/cat/" + (item.cat || undefined)}
						title={item.title}
						excerpt={item.content.content.excerpt}
						published={item.datePublished}
						featured_img={item.featuredImage}
						url={"/" + item.node_locale + "/news/" + item.slug}
					/>
				</div>
			);
		}
		return null;
	});
};

class News extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			currentCat: "opinion",

			loadMore: true
		};
	}
	componentDidMount() {
		// const hashCategory = capitalizeFirstLetter(
		// 	this.props.location.hash.slice(1)
		// );

		// if (hashCategory) {
		// 	this.setState({
		// 		currentCat: capitalizeFirstLetter(
		// 			this.props.location.hash.slice(1)
		// 		)
		// 	});
		// } else {
			this.setState({ currentCat: this.props.pathContext.type });
		// }
	}

	handleClick = category => {
		// this.loadPublications(year);
		this.setState({ currentCat: category });
	};

	render() {
		var news = [];
		if (this.props.data.news) {
			news = this.props.data.news.edges.map(item => {
				return item.node;
			});
		}

		const { pageSettings } = this.props.data;

		const navList = [
			{
				label: "Latest",
				name: "latest",
				href: `/${pageSettings.node_locale}/news`
			},
			{
				label: "News",
				name: "news",
				href: `/${pageSettings.node_locale}/news/cat/news`
			},
			{
				label: "Opinions",
				name: "opinion",
				href: `/${pageSettings.node_locale}/news/cat/opinion`
			},
			{
				label: "Resources",
				name: "resource",
				href: `/${pageSettings.node_locale}/news/cat/resource`
			}
		];

		const { transition } = this.props;
		return (
			<PageWrapper locale={pageSettings.node_locale} location={this.props.location} data={this.props.data.layout.edges[0].node}>
				<main role="main" style={transition && transition.style}>
					<Jumbotron
						type="jumbotron_b"
						bottomLine={true}
						className="mb-0"
						textAlign="text-center"
						contentAlign="justify-content-md-center"
					>
						<h1 className={styles.jumbo_h1 }>News</h1>
					</Jumbotron>
	
					<div className="grey_bg">
						<div
							className="container"
							style={{ transform: "translateY(-50%)" }}
						>
							<div className="row justify-content-center">
								<div className="col-10 col-sm-10 col-lg-10">
									<SubNav
										active={this.state.currentCat}
										navList={navList}
										handleClick={() => {}}
									/>
								</div>
							</div>
						</div>
	
						<div className="container pt-lg-5 pb-5">
							<div className="row">
								{news && news.length > 0 ? (
									renderItems(news)
								) : (
									<div className="col-12 card mb-3 py-5 text-center">
										<h2>Coming soon!</h2>
										<br />
										<h4>
											We are still preparing the{" "}
											<span
												style={{
													textTransform: "lowercase"
												}}
											>
												{this.state.currentCat}
											</span>. Come back soon!
										</h4>
									</div>
								)}
	
								{/* <div className="col-12 text-center mt-5	">
								<button role="button" className="button">
									Load More
								</button>
							</div> */}
							</div>
						</div>
					</div>
				</main>
			</PageWrapper>
		);
	}
}

export default News;

export const query = graphql`
	query NewsPageTypeQuery($id: String!, $locale: String!, $type: String!) {
		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}

		pageSettings: contentfulNewsPage(id: { eq: $id }) {
			pageTitle
			metaDescription {
				metaDescription
			}
			node_locale
		}

		news: allContentfulNews(
			filter: { node_locale: { eq: $locale }, cat: { eq: $type } }
			sort: { order: DESC, fields: [datePublished] }
		) {
			edges {
				node {
					title
					datePublished(formatString: "Do MMMM, YYYY")
					slug
					featuredImage {
						title
						resolutions(
							height: 250
							quality: 85
							cropFocus: FACES
							resizingBehavior: NO_CHANGE
						) {
							base64
							aspectRatio
							width
							height
							src
							srcSet
							srcWebp
							srcSetWebp
						}
					}
					cat
					content {
						content: childMarkdownRemark {
							excerpt(pruneLength: 220)
						}
					}
					node_locale
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/news-page-type-template.js